import { BaseGenerator } from '../core/BaseGenerator.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * FIN generator following Single Responsibility Principle
 */
export class FinGenerator extends BaseGenerator {
  generate(options = {}) {
    const { prefix = null } = options;
    
    const prefixes = ['F', 'G'];
    const selectedPrefix = prefix || prefixes[this.randomInt(0, prefixes.length - 1)];
    
    const digits = this.randomDigits(7);
    const partial = selectedPrefix + digits;
    const checksum = ChecksumCalculator.calculateNricChecksum(partial + 'A');
    
    return partial + checksum;
  }
}